import { httpClient } from "../../../shared/api";

function cleanQuery(query = {}) {
  const out = {};
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    out[k] = v;
  });
  return out;
}

export const retroApi = {
  health() {
    return httpClient.get("/retro/health");
  },

  listCycles() {
    return httpClient.get("/retro/cycles");
  },

  listMyRetros(params = {}) {
    return httpClient.get("/retro/retros/my", { query: cleanQuery(params) });
  },

  listTeamRetros(params = {}) {
    return httpClient.get("/retro/retros/team", { query: cleanQuery(params) });
  },

  listGoals(retroId) {
    return httpClient.get(`/retro/retros/${retroId}/goals`);
  },

  listReflectionPeriods(params = {}) {
    return httpClient.get("/retro/reflections/periods", { query: cleanQuery(params) });
  },

  listReflectionAnswers(periodId) {
    return httpClient.get(`/retro/reflections/periods/${periodId}/answers`);
  },

  getDashboardSummary({ cycleId, resourceId } = {}) {
    return httpClient.get("/retro/dashboard/summary", {
      query: cleanQuery({ cycle_id: cycleId, resource_id: resourceId }),
    });
  },
};
